/**
 * What a free account can generate, and what we say when it cannot.
 *
 * The trial used to include three complete page setups: schema plus hosted
 * AI-readable files, copyable and deployable. For a lot of our customers three
 * pages is the entire site, so the trial handed over the whole deliverable and
 * there was nothing left to sell. Conversion into pricing stopped.
 *
 * Generation is now part of a subscription. The free account still gets the
 * full AI Visibility report and the onboarding fix flow, which demonstrates a
 * real generated fix for one page without handing it over.
 *
 * Both constants live here, in shared, because the limit was previously
 * declared twice (server entitlements and a client copy) and the wording was
 * duplicated across thirteen call sites. Two of those going out of sync means
 * promising something we no longer give.
 */
export const FREE_TIER_PAGE_SETUP_LIMIT = 0;
/** Shown wherever someone on a free account reaches for generation. */
export const PAGE_SETUP_SUBSCRIPTION_REQUIRED_MESSAGE = 'Generating schema and AI-readable files is part of a subscription. Choose a plan to set up your pages.';
/**
 * The same paywall, to an account whose team has had its free first page.
 * The page was a grant, given once per website through Put it live; the
 * limit above is still zero.
 */
export const PAGE_SETUP_AFTER_FREE_PAGE_MESSAGE = 'Your first page was free. The next one comes with a plan.';
/** The one-line plan description on billing and account surfaces. */
export const FREE_TIER_PLAN_DESCRIPTION = 'Your free account includes the full AI Visibility report. Schema and AI-readable files come with a subscription.';
/** Paid trials have a separate cap from the free first-page grant. */
export const TRIAL_PAGE_LIMIT_CODE = 'trial_page_limit';
export const TRIAL_PAGE_LIMIT_MESSAGE = 'You’ve used your 20 trial pages. Start your paid plan in Billing to keep generating schema and AI-readable files.';
